import { useVersionDeleted } from './useVersionDeleted'
import { useVersionUploadComplete } from './useVersionUploadComplete'
import { useVersionUploadProcessed } from './useVersionUploadProcessed'
import { useVersionUpdated } from './useVersionUpdated/useVersionUpdated'

export const useVersionSubscriptions = () => {
  /**
   * Subscription receiving a new version.
   * The order is:
   * 1. Version Uploaded -> useVersionUploadComplete
   * 2. Versin Processed -> useVersionUploadProcessed
   *
   * Note: the order of these subscriptions matters for handleDocumentUploadEvent test
   */
  useVersionUploadProcessed()
  useVersionUploadComplete()

  useVersionDeleted()

  // This subscription is fired when a version has been starred/unstarred
  useVersionUpdated()
}
